/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 * Lean row for company meeting listings --- full snapshot is fetched per-meeting on demand.
 * @export
 * @interface CompanyMeetingSummary
 */
export interface CompanyMeetingSummary {
  /**
   *
   * @type {string}
   * @memberof CompanyMeetingSummary
   */
  companyMeetingId: string;
  /**
   *
   * @type {string}
   * @memberof CompanyMeetingSummary
   */
  title?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyMeetingSummary
   */
  meetingDate?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof CompanyMeetingSummary
   */
  summaryShort?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyMeetingSummary
   */
  createdAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof CompanyMeetingSummary
   */
  createdBy?: string | null;
}

/**
 * Check if a given object implements the CompanyMeetingSummary interface.
 */
export function instanceOfCompanyMeetingSummary(
  value: object,
): value is CompanyMeetingSummary {
  if (!("companyMeetingId" in value) || value["companyMeetingId"] === undefined)
    return false;
  return true;
}

export function CompanyMeetingSummaryFromJSON(
  json: any,
): CompanyMeetingSummary {
  return CompanyMeetingSummaryFromJSONTyped(json, false);
}

export function CompanyMeetingSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyMeetingSummary {
  if (json == null) {
    return json;
  }
  return {
    companyMeetingId: json["companyMeetingId"],
    title: json["title"] == null ? undefined : json["title"],
    meetingDate: json["meetingDate"] == null ? undefined : json["meetingDate"],
    summaryShort:
      json["summaryShort"] == null ? undefined : json["summaryShort"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
  };
}

export function CompanyMeetingSummaryToJSON(json: any): CompanyMeetingSummary {
  return CompanyMeetingSummaryToJSONTyped(json, false);
}

export function CompanyMeetingSummaryToJSONTyped(
  value?: CompanyMeetingSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyMeetingId: value["companyMeetingId"],
    title: value["title"],
    meetingDate: value["meetingDate"],
    summaryShort: value["summaryShort"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
  };
}
